import type { RootState } from '..';
import type { ClockState } from './types';

export const getClockState = (state: RootState): ClockState => state.clock;
export const getClockTime = (state: RootState): string => getClockState(state).date;
